import "./contact.css";

import React, { Component } from "react";
import { InlineSpinner } from "../components/InlineSpinner";

import PropTypes from "prop-types";
import banner from "../static/img/system_bg.webp";
import { connect } from "react-redux";
import literal from "../static/img/fav-literal.png";
import phenolite from "../static/img/fav-phenolite.png";
import phenomobile from "../static/img/fav-phenomobile.png";
import phenoresearch from "../static/img/fav-phenoresearch.png";
import phenoscale from "../static/img/fav-phenoscale.png";
import phenostation from "../static/img/fav-phenostation.png";
import { sendContactMail } from "../actions/user";
import wps from "../static/img/wps.svg";

// Produits, logos et liens repris tels quels du menu switcher (components/Navbar/Navbar.jsx).
const PRODUCTS = [
  {
    name: "PhenoScale",
    url: "https://hiphen-phenoscale.com/hub/",
    logo: phenoscale,
  },
  {
    name: "PhenoMobile",
    url: "https://www.hiphen-phenomobile.com/hub",
    logo: phenomobile,
  },
  { name: "Literal", url: "https://hiphen-literal.com/hub/", logo: literal },
  { name: "PhenoLite", url: "https://hiphen-phenolite.com/", logo: phenolite },
  {
    name: "PhenoStation",
    url: "https://hiphen-phenostation.com/",
    logo: phenostation,
  },
  {
    name: "PhenoResearch",
    url: "https://hiphen-phenoresearch.com/",
    logo: phenoresearch,
  },
  { name: "Hiphen WPS", url: "https://hiphen-wps.com/", logo: wps },
];

class ClientHelp extends Component {
  constructor(props) {
    super(props);
    this.state = { sending: false };
    this.mail = React.createRef();
    this.object = React.createRef();
    this.content = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const subject = this.object.current;
    const content = this.content.current;
    // Rejette les champs vides OU composés uniquement d'espaces / retours ligne.
    subject.setCustomValidity(
      subject.value.trim() ? "" : "Please enter a subject."
    );
    content.setCustomValidity(
      content.value.trim() ? "" : "Please enter a message."
    );
    if (
      !this.mail.current.reportValidity() ||
      !subject.reportValidity() ||
      !content.reportValidity()
    )
      return;

    this.setState({ sending: true });
    const started = Date.now();
    this.props
      .sendContactMail({
        reply_to: this.mail.current.value.trim(),
        subject: subject.value.trim(),
        body: content.value.trim(),
      })
      .then(() => {
        // Succès : on vide sujet et message (l'email pré-rempli reste).
        subject.value = "";
        content.value = "";
      })
      .catch(() => {
        // Échec déjà signalé par l'action ; on conserve la saisie.
      })
      .finally(() => {
        // ponytail: garde le spinner au moins 500ms, sinon un envoi
        // quasi instantané ne laisse rien voir.
        const wait = Math.max(0, 500 - (Date.now() - started));
        setTimeout(() => this.setState({ sending: false }), wait);
      });
  }

  render() {
    return (
      <div className="page-content">
        <div className="ct-contact">
          <div className="ct-banner">
            <img
              src={banner}
              alt="Hiphen field phenotyping ecosystem: a drone, a handheld Literal and a PhenoMobile ground vehicle capturing measurements over a crop field."
            />
          </div>

          <section className="ct-intro">
            <div className="ct-copy">
              <p className="ct-eyebrow">Get in touch</p>
              <h1>
                Turning field imagery into <em>agronomic data</em>.
              </h1>
              <p className="ct-lead">
                Deep agronomic knowledge combined with AI-powered imaging to
                deliver valuable plant phenomics data, from the field to the
                trait.
              </p>
              <ul className="ct-points">
                <li>
                  Multi-source imaging: drone, ground, station and satellite
                </li>
                <li>From raw field images to agronomic traits</li>
                <li>One data platform to explore, compare and share results</li>
              </ul>
            </div>

            <form
              className="ct-card"
              id="contactForm"
              onSubmit={this.handleSubmit}
            >
              <h2>Contact us</h2>
              <p className="ct-sub">
                A question, a project, a demo request. We usually reply within
                one business day.
              </p>
              <div className="ct-field">
                <label htmlFor="mail">
                  Email <span className="ct-req">*</span>
                </label>
                <input
                  type="email"
                  ref={this.mail}
                  id="mail"
                  defaultValue={this.props.user.email}
                  placeholder="you@company.com"
                  required
                />
              </div>
              <div className="ct-field">
                <label htmlFor="object">
                  Subject <span className="ct-req">*</span>
                </label>
                <input
                  type="text"
                  ref={this.object}
                  id="object"
                  placeholder="What is this about?"
                  required
                  onInput={(e) => e.currentTarget.setCustomValidity("")}
                />
              </div>
              <div className="ct-field">
                <label htmlFor="content">
                  Message <span className="ct-req">*</span>
                </label>
                <textarea
                  rows="5"
                  ref={this.content}
                  id="content"
                  placeholder="Tell us a bit about your need…"
                  required
                  onInput={(e) => e.currentTarget.setCustomValidity("")}
                />
              </div>
              <button
                className="ct-send"
                type="submit"
                disabled={this.state.sending}
              >
                {this.state.sending ? (
                  <>
                    <InlineSpinner /> Sending...
                  </>
                ) : (
                  "Send message"
                )}
              </button>
            </form>
          </section>

          <section className="ct-eco">
            <div className="ct-eco-head">
              <h3>The Hiphen ecosystem</h3>
            </div>
            <div className="ct-grid">
              {PRODUCTS.map((p) => (
                <a
                  key={p.name}
                  className="ct-prod"
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="ct-prod-logo" src={p.logo} alt="" />
                  <b>{p.name}</b>
                  <i className="fa-solid fa-up-right-from-square ct-ext" />
                </a>
              ))}
            </div>
          </section>

          <footer className="ct-foot">
            <span>
              © Hiphen · Plant phenomics, from the field to the trait.
            </span>
            <span>
              <a
                href="https://www.hiphen-plant.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                hiphen-plant.com
              </a>{" "}
              ·{" "}
              <a
                href="https://www.linkedin.com/company/hiphen/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </span>
          </footer>
        </div>
      </div>
    );
  }
}

function mapStateToProps(store) {
  return {
    user: store.user.self,
  };
}

const callbacks = {
  sendContactMail,
};

export default connect(mapStateToProps, callbacks)(ClientHelp);

ClientHelp.propTypes = {
  user: PropTypes.object.isRequired,
  sendContactMail: PropTypes.func.isRequired,
};
